// src/components/ErrorPopup.js

import React, { useContext } from 'react';
import { ErrorContext } from '../context/ErrorContext';
import './css/ErrorPopup.css'; // Create this CSS file for styling

const ErrorPopup = () => {
  const { error, errorType } = useContext(ErrorContext);
  if (!error) return null;
  return (
    <div className={`error-popup ${errorType === 'info' ? 'error-popup--info' : 'error-popup--error'}`}>
      <p>{error}</p>
    </div>
  );
};

export default ErrorPopup;
